import { useEffect, useState } from "react";
import { getSupabase, currentUser } from "@/lib/supabase";

export function useSubscription() {
  const [status, setStatus] = useState<string>("loading");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const user = await currentUser();
        if (!user) {
          setStatus("cancelled");
          setIsLoading(false);
          return;
        }

        const { data, error } = await getSupabase()
          .from("clients")
          .select("subscription_status")
          .eq("user_id", user.id)
          .single();

        if (error || !data) {
          setStatus("cancelled");
        } else {
          setStatus(data.subscription_status || "cancelled");
        }
      } catch (err) {
        setStatus("cancelled");
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const canAccessPremium = status === "active" || status === "past_due";

  return { status, isLoading, canAccessPremium };
}
